import { useMemo } from 'react';
import hexRgb from 'hex-rgb';
import rgbHex from 'rgb-hex';
export function convertHex(hex) {
  var noAlpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var _hexRgb = hexRgb(hex),
      red = _hexRgb.red,
      green = _hexRgb.green,
      blue = _hexRgb.blue,
      alpha = _hexRgb.alpha;

  return noAlpha ? [red / 255, green / 255, blue / 255] : [red / 255, green / 255, blue / 255, alpha];
}
export function convertRgb(rgb) {
  var noAlpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var _hexRgb2 = hexRgb(rgbHex(rgb)),
      red = _hexRgb2.red,
      green = _hexRgb2.green,
      blue = _hexRgb2.blue,
      alpha = _hexRgb2.alpha;

  return noAlpha ? [red / 255, green / 255, blue / 255] : [red / 255, green / 255, blue / 255, alpha];
}
export function useHex(hex, noAlpha) {
  var color = useMemo(function () {
    return convertHex(hex, noAlpha);
  }, [hex, noAlpha]);
  return color;
}
export function useRgb(rgb, noAlpha) {
  var color = useMemo(function () {
    return convertRgb(rgb, noAlpha);
  }, [rgb, noAlpha]);
  return color;
}